// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.95.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.95.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  text-decoration: none;
  list-style: none;
}

body {
  margin: 0;
  padding: 0;
  font-family: Poppins, Arial, Helvetica, sans-serif;
}

.skip-to-content {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fdde55;
  color: #333;
  padding: 0.5em 1em;
  font-size: 1em;
  z-index: 2;
  text-decoration: none;
}

.skip-to-content:focus {
  z-index: 9;
  outline: none;
  box-shadow: 0 0 0 2px #333;
}

a[href^='#'] {
  scroll-behavior: smooth;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  background-color: #fdde55;
  position: sticky;
  top: 0;
  z-index: 2;
}

.drawer {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  flex-direction: column;
  background-color: #fdde55;
  padding: 1em;
  margin: 0;
  transform: translateY(-100%);
  transition: transform 0.3s ease-in-out;
}

.drawer.show {
  display: flex;
  transform: translateY(0);
}

.drawer > li > a {
  color: white;
  font-size: 2em;
  font-weight: 700;
  transition: color 0.2s ease-in-out;
}

.drawer > li > a:hover {
  color: #333;
}

.menu {
  width: 44px;
  height: 44px;
  display: block;
  text-align: center;
  font-size: 1.5em;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  background-color: #fdde55;
  border: 0;
}

.menu:hover {
  transform: scale(1.1);
}

.hero {
  display: grid;
  align-items: center;
  justify-items: center;
  text-align: center;
  width: 100vw;
  height: 100vh;
  max-width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.heroInner {
  max-width: 100%;
  padding: 0 1em;
}

.heroTitle {
  color: white;
  margin-top: 16px;
  font-weight: 300;
  font-size: 2.5em;
  transition: font-size 0.3s ease-in-out;
}

.heroTagline {
  color: white;
  font-size: 1.2em;
  transition: font-size 0.3s ease-in-out;
}

.hero picture {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: -1;
}

.hero picture img {
  width: 100%;
  height: 100vh;
  object-fit: cover;
  z-index: -1;
}

.skeleton {
  opacity: 0.7;
  background-color: #ddd;
  border-radius: 8px;
  animation: skeleton-loading 1s linear infinite alternate;
}

.skeleton-image {
  height: 250px;
  background-color: #ddd;
  border-radius: 8px 8px 0 0;
}

.skeleton-text {
  height: 1.2em;
  background-color: #ddd;
  border-radius: 4px;
  margin-bottom: 0.5em;
}

@keyframes skeleton-loading {
  0% {
    background-color: #ddd;
  }
  100% {
    background-color: #ececec;
  }
}

.content {
  padding: 1em;
}

.content > h1 {
  text-align: center;
  font-size: 1.5em;
  color: #fdde55;
}

.restaurantList {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1em;
}

.restaurantItem {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.restaurantItem img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
}

.restaurantItem .restaurantContent {
  padding: 0 1em;
}

.restaurantItem .restaurantTitle {
  font-size: 1.4em;
  color: #fdde55;
}

.restaurantItem .restaurantDesc {
  font-size: 0.9em;
}

.restaurantItem .restaurantRating::before {
  content: '\\2605';
  color: #fdde55;
  width: 50px;
}

.restaurantItem .restaurantCity::before {
  content: '\\1F4CD';
}

.restaurantDetail {
  max-width: 800px;
  margin: 20px auto;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.restaurantDetail img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.restaurantDetail > .restaurantContent {
  padding: 20px;
}

.restaurantDetail .restaurantTitle {
  font-size: 2.5em;
  color: #333;
  margin-bottom: 0.5em;
}

.restaurantDetail .restaurantInfo h3,
.restaurantDetail .restaurantDesc h3 {
  font-size: 1.8em;
  color: #fdde55;
  margin-bottom: 0.5em;
}

.restaurantDetail .restaurantInfo h4,
.restaurantDetail .restaurantDesc h4 {
  font-size: 1.2em;
  color: #555;
  margin-bottom: 0.3em;
}

.restaurantDetail .restaurantInfo p,
.restaurantDetail .restaurantDesc p {
  font-size: 1em;
  color: #666;
  margin-bottom: 1em;
}

.restaurantDetail .restaurantRating {
  font-size: 1.5em;
  color: #fdde55;
}

.restaurantDetail .restaurantMenu {
  margin-top: 2em;
}

.restaurantDetail .restaurantMenu h3 {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 1em;
}

.restaurantDetail .restaurantMenu .foods,
.restaurantDetail .restaurantMenu .drinks {
  margin-bottom: 1.5em;
}

.restaurantDetail .restaurantMenu h4 {
  font-size: 1.5em;
  color: #fdde55;
  margin-bottom: 0.5em;
  border-bottom: 2px solid #fdde55;
  padding-bottom: 0.3em;
}

.restaurantDetail .restaurantMenu ul {
  list-style-type: none;
  padding: 0;
}

.restaurantDetail .restaurantMenu ul li {
  background-color: #f9f9f9;
  padding: 10px 15px;
  margin: 5px 0;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.restaurantDetail .restaurantMenu ul li:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}

.restaurantDetail .customerReviews {
  margin-top: 2em;
}

.restaurantDetail .customerReviews h3 {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 1em;
}

.restaurantDetail .customerReviews ul {
  list-style-type: none;
  padding: 0;
}

.restaurantDetail .customerReviews ul li {
  background-color: #f9f9f9;
  padding: 10px 15px;
  margin: 5px 0;
  border-radius: 5px;
}

.restaurantDetail .customerReviews ul li strong {
  color: #333;
}

.restaurantDetail .customerReviews ul li p {
  margin: 0;
  color: #666;
}

.review-form {
  max-width: 500px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.review-form h2 {
  margin-top: 0;
  font-size: 24px;
  color: #333;
}

.review-form label {
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  color: #666;
}

.review-form input,
.review-form textarea {
  min-height: 44px;
  width: 100%;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.review-form textarea {
  height: 100px;
  resize: vertical;
}

.review-form .submit-btn {
  min-height: 44px;
  width: 100%;
  padding: 10px;
  background-color: #fdde55;
  color: #333;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.review-form .submit-btn:hover {
  background-color: #ffd700;
}

img {
  display: block;
}

.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #db0000;

  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;

  font-size: 18px;
  color: white;
  cursor: pointer;
}

footer {
  background-color: #fdde55;
  padding: 1em;
  text-align: center;
}

footer > p {
  font-size: 2em;
}

.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #fdde55;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (min-width: 650px) {
  nav {
    padding: 1em 2em;
  }

  .menu {
    display: none;
  }

  .drawer {
    display: flex;
    position: static;
    width: auto;
    flex-direction: row;
    background-color: transparent;
    padding: 0;
    gap: 1em;
    transform: translate(0, 0);
  }

  .heroTitle {
    font-size: 3em;
  }

  .heroTagline {
    font-size: 1.3em;
  }

  .content {
    padding: 1.5em;
  }

  .content > h1 {
    font-size: 1.8em;
  }

  .restaurantList {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5em;
  }

  .restaurantItem > img {
    max-height: 300px;
  }

  .restaurantDesc {
    font-size: 1em;
  }
}

@media screen and (min-width: 1000px) {
  nav {
    padding: 1em 4em;
  }

  .heroInner {
    max-width: 800px;
  }

  .heroTitle {
    font-size: 4em;
  }

  .heroTagline {
    font-size: 1.5em;
  }

  .content {
    padding: 2em;
  }

  .content > h1 {
    font-size: 2em;
  }

  .restaurantList {
    grid-template-columns: repeat(3, 1fr);
    gap: 2vw;
  }

  .restaurantItem > img {
    max-height: 350px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;;EAET,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,QAAQ;IACR,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n\n* {\n  box-sizing: border-box;\n  text-decoration: none;\n  list-style: none;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: Poppins, Arial, Helvetica, sans-serif;\n}\n\n.skip-to-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #fdde55;\n  color: #333;\n  padding: 0.5em 1em;\n  font-size: 1em;\n  z-index: 2;\n  text-decoration: none;\n}\n\n.skip-to-content:focus {\n  z-index: 9;\n  outline: none;\n  box-shadow: 0 0 0 2px #333;\n}\n\na[href^='#'] {\n  scroll-behavior: smooth;\n}\n\nnav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1em;\n  background-color: #fdde55;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.drawer {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  flex-direction: column;\n  background-color: #fdde55;\n  padding: 1em;\n  margin: 0;\n  transform: translateY(-100%);\n  transition: transform 0.3s ease-in-out;\n}\n\n.drawer.show {\n  display: flex;\n  transform: translateY(0);\n}\n\n.drawer > li > a {\n  color: white;\n  font-size: 2em;\n  font-weight: 700;\n  transition: color 0.2s ease-in-out;\n}\n\n.drawer > li > a:hover {\n  color: #333;\n}\n\n.menu {\n  width: 44px;\n  height: 44px;\n  display: block;\n  text-align: center;\n  font-size: 1.5em;\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n  background-color: #fdde55;\n  border: 0;\n}\n\n.menu:hover {\n  transform: scale(1.1);\n}\n\n.hero {\n  display: grid;\n  align-items: center;\n  justify-items: center;\n  text-align: center;\n  width: 100vw;\n  height: 100vh;\n  max-width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.heroInner {\n  max-width: 100%;\n  padding: 0 1em;\n}\n\n.heroTitle {\n  color: white;\n  margin-top: 16px;\n  font-weight: 300;\n  font-size: 2.5em;\n  transition: font-size 0.3s ease-in-out;\n}\n\n.heroTagline {\n  color: white;\n  font-size: 1.2em;\n  transition: font-size 0.3s ease-in-out;\n}\n\n.hero picture {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n  z-index: -1;\n}\n\n.hero picture img {\n  width: 100%;\n  height: 100vh;\n  object-fit: cover;\n  z-index: -1;\n}\n\n.skeleton {\n  opacity: 0.7;\n  background-color: #ddd;\n  border-radius: 8px;\n  animation: skeleton-loading 1s linear infinite alternate;\n}\n\n.skeleton-image {\n  height: 250px;\n  background-color: #ddd;\n  border-radius: 8px 8px 0 0;\n}\n\n.skeleton-text {\n  height: 1.2em;\n  background-color: #ddd;\n  border-radius: 4px;\n  margin-bottom: 0.5em;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-color: #ddd;\n  }\n  100% {\n    background-color: #ececec;\n  }\n}\n\n.content {\n  padding: 1em;\n}\n\n.content > h1 {\n  text-align: center;\n  font-size: 1.5em;\n  color: #fdde55;\n}\n\n.restaurantList {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1em;\n}\n\n.restaurantItem {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n}\n\n.restaurantItem img {\n  width: 100%;\n  height: 250px;\n  object-fit: cover;\n  border-radius: 8px 8px 0 0;\n}\n\n.restaurantItem .restaurantContent {\n  padding: 0 1em;\n}\n\n.restaurantItem .restaurantTitle {\n  font-size: 1.4em;\n  color: #fdde55;\n}\n\n.restaurantItem .restaurantDesc {\n  font-size: 0.9em;\n}\n\n.restaurantItem .restaurantRating::before {\n  content: '\\2605';\n  color: #fdde55;\n  width: 50px;\n}\n\n.restaurantItem .restaurantCity::before {\n  content: '\\1F4CD';\n}\n\n.restaurantDetail {\n  max-width: 800px;\n  margin: 20px auto;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.restaurantDetail img {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.restaurantDetail > .restaurantContent {\n  padding: 20px;\n}\n\n.restaurantDetail .restaurantTitle {\n  font-size: 2.5em;\n  color: #333;\n  margin-bottom: 0.5em;\n}\n\n.restaurantDetail .restaurantInfo h3,\n.restaurantDetail .restaurantDesc h3 {\n  font-size: 1.8em;\n  color: #fdde55;\n  margin-bottom: 0.5em;\n}\n\n.restaurantDetail .restaurantInfo h4,\n.restaurantDetail .restaurantDesc h4 {\n  font-size: 1.2em;\n  color: #555;\n  margin-bottom: 0.3em;\n}\n\n.restaurantDetail .restaurantInfo p,\n.restaurantDetail .restaurantDesc p {\n  font-size: 1em;\n  color: #666;\n  margin-bottom: 1em;\n}\n\n.restaurantDetail .restaurantRating {\n  font-size: 1.5em;\n  color: #fdde55;\n}\n\n.restaurantDetail .restaurantMenu {\n  margin-top: 2em;\n}\n\n.restaurantDetail .restaurantMenu h3 {\n  font-size: 1.8em;\n  color: #333;\n  margin-bottom: 1em;\n}\n\n.restaurantDetail .restaurantMenu .foods,\n.restaurantDetail .restaurantMenu .drinks {\n  margin-bottom: 1.5em;\n}\n\n.restaurantDetail .restaurantMenu h4 {\n  font-size: 1.5em;\n  color: #fdde55;\n  margin-bottom: 0.5em;\n  border-bottom: 2px solid #fdde55;\n  padding-bottom: 0.3em;\n}\n\n.restaurantDetail .restaurantMenu ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.restaurantDetail .restaurantMenu ul li {\n  background-color: #f9f9f9;\n  padding: 10px 15px;\n  margin: 5px 0;\n  border-radius: 5px;\n  transition: background-color 0.3s;\n}\n\n.restaurantDetail .restaurantMenu ul li:hover {\n  background-color: #f0f0f0;\n  cursor: pointer;\n}\n\n.restaurantDetail .customerReviews {\n  margin-top: 2em;\n}\n\n.restaurantDetail .customerReviews h3 {\n  font-size: 1.8em;\n  color: #333;\n  margin-bottom: 1em;\n}\n\n.restaurantDetail .customerReviews ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.restaurantDetail .customerReviews ul li {\n  background-color: #f9f9f9;\n  padding: 10px 15px;\n  margin: 5px 0;\n  border-radius: 5px;\n}\n\n.restaurantDetail .customerReviews ul li strong {\n  color: #333;\n}\n\n.restaurantDetail .customerReviews ul li p {\n  margin: 0;\n  color: #666;\n}\n\n.review-form {\n  max-width: 500px;\n  margin: 20px auto;\n  padding: 20px;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.review-form h2 {\n  margin-top: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.review-form label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 18px;\n  color: #666;\n}\n\n.review-form input,\n.review-form textarea {\n  min-height: 44px;\n  width: 100%;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.review-form textarea {\n  height: 100px;\n  resize: vertical;\n}\n\n.review-form .submit-btn {\n  min-height: 44px;\n  width: 100%;\n  padding: 10px;\n  background-color: #fdde55;\n  color: #333;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.review-form .submit-btn:hover {\n  background-color: #ffd700;\n}\n\nimg {\n  display: block;\n}\n\n.like {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #db0000;\n\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n\n  font-size: 18px;\n  color: white;\n  cursor: pointer;\n}\n\nfooter {\n  background-color: #fdde55;\n  padding: 1em;\n  text-align: center;\n}\n\nfooter > p {\n  font-size: 2em;\n}\n\n.loader {\n  border: 16px solid #f3f3f3;\n  border-top: 16px solid #fdde55;\n  border-radius: 50%;\n  width: 120px;\n  height: 120px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media screen and (min-width: 650px) {\n  nav {\n    padding: 1em 2em;\n  }\n\n  .menu {\n    display: none;\n  }\n\n  .drawer {\n    display: flex;\n    position: static;\n    width: auto;\n    flex-direction: row;\n    background-color: transparent;\n    padding: 0;\n    gap: 1em;\n    transform: translate(0, 0);\n  }\n\n  .heroTitle {\n    font-size: 3em;\n  }\n\n  .heroTagline {\n    font-size: 1.3em;\n  }\n\n  .content {\n    padding: 1.5em;\n  }\n\n  .content > h1 {\n    font-size: 1.8em;\n  }\n\n  .restaurantList {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5em;\n  }\n\n  .restaurantItem > img {\n    max-height: 300px;\n  }\n\n  .restaurantDesc {\n    font-size: 1em;\n  }\n}\n\n@media screen and (min-width: 1000px) {\n  nav {\n    padding: 1em 4em;\n  }\n\n  .heroInner {\n    max-width: 800px;\n  }\n\n  .heroTitle {\n    font-size: 4em;\n  }\n\n  .heroTagline {\n    font-size: 1.5em;\n  }\n\n  .content {\n    padding: 2em;\n  }\n\n  .content > h1 {\n    font-size: 2em;\n  }\n\n  .restaurantList {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2vw;\n  }\n\n  .restaurantItem > img {\n    max-height: 350px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
